import * as React from 'react';
import {
  useCreateController,
  CreateContextProvider,
  SimpleForm,
  CreateProps,
  TextInput,
  NumberInput,
  BooleanInput,
  required,
} from 'react-admin';
import { IconButton, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';

import { ChefListFragment } from '../generated/graphql';

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: 40,
  },
  title: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    margin: '1em',
  },
  form: {
    [theme.breakpoints.up('xs')]: {
      width: 400,
    },
    [theme.breakpoints.down('xs')]: {
      width: '100vw',
      marginTop: -30,
    },
  },
  inlineField: {
    display: 'inline-block',
    width: '50%',
  },
}));

interface Props extends CreateProps {
  onCancel: () => void;
}

const ChefCreate = ({ onCancel, ...props }: Props) => {
  const classes = useStyles();
  const controllerProps = useCreateController<ChefListFragment>(props);

  if (!controllerProps.record) {
    return null;
  }
  return (
    <div className={classes.root}>
      <div className={classes.title}>
        <Typography variant="h6">Ajouter un chef</Typography>
        <IconButton onClick={onCancel}>
          <CloseIcon />
        </IconButton>
      </div>
      <CreateContextProvider value={controllerProps}>
        <SimpleForm
          className={classes.form}
          basePath={controllerProps.basePath}
          record={controllerProps.record}
          save={controllerProps.save}
          version={controllerProps.version}
          redirect="list"
          resource="reviews"
          toolbar={<></>}
        >
          <TextInput
            fullWidth
            label="Prénom"
            source="firstname"
            validate={required()}
          />
          <TextInput
            fullWidth
            label="Nom"
            source="lastname"
            validate={required()}
          />
          <TextInput
            fullWidth
            label="Description"
            source="description"
            validate={required()}
          />
          <NumberInput
            fullWidth
            label="Ordre"
            source="order"
            validate={required()}
          />
          <BooleanInput
            label="Actif"
            source="is_active"
            defaultValue={true}
            validate={required()}
          />
        </SimpleForm>
      </CreateContextProvider>
    </div>
  );
};

export default ChefCreate;
